/**
 * 在线数据异步导出(实时/分钟/小时数据):
 * 覆盖ChangeColMixin的同步导出, 改为提交后台导出任务(导出时间独立于页面查询, 最长31天),
 * 任务进度与文件在"导出中心"抽屉中管理。
 * 注意: 必须放在mixins数组中ChangeColMixin之后, 才能覆盖其handleExportXls。
 */
export const OnlineExportMixin = {
  data() {
    return {
      // 页面可显式声明: '2011'实时 '2051'分钟 '2061'小时; 未声明时按exportUrl推断
      exportDataType: ''
    }
  },
  methods: {
    // 导出中心入口: 打开双Tab弹窗并默认切换至【导出文件】
    openExportCenter() {
      if ((this.queryParam.scope || 0) != 1 || !this.queryParam.scopeId) {
        this.$message_custom('仅支持单站点导出', 'warning')
        return
      }
      this.$bus.$emit('online-export:open-dialog', {
        ...this.buildExportInfo(),
        defaultTab: 'files'
      })
    },
    // 异步导出: 仅校验并打开提交弹窗, 不再发任何请求, 导出范围天然与页面查询/分页隔离
    handleExportXls() {
      if ((this.queryParam.scope || 0) != 1 || !this.queryParam.scopeId) {
        this.$message_custom('仅支持单站点导出', 'warning')
        return
      }
      this.$bus.$emit('online-export:open-dialog', this.buildExportInfo())
    },
    buildExportInfo() {
      let factorCodes = ''
      if (this.$refs.colControl && this.$refs.colControl.selectCol) {
        factorCodes = this.$refs.colControl.selectCol.join(',')
      }
      return {
        dataType: this.exportDataType || this.detectDataType(),
        scope: this.queryParam.scope,
        scopeId: this.queryParam.scopeId,
        st: this.queryParam.st,
        siteName: window.sessionStorage.getItem('siteName') || '',
        factorCodes: factorCodes,
        onlineData: this.queryParam.onlineData,
        productionStatus: this.queryParam.productionStatus,
        // 预填导出时间为当前页面查询范围, 可自由修改(最长31天)
        suggestedRange: [this.queryParam.stime, this.queryParam.etime]
      }
    },
    detectDataType() {
      const url = this.exportUrl || ''
      if (url.indexOf('/export/2011') > -1) return '2011'
      if (url.indexOf('/export/2051') > -1) return '2051'
      if (url.indexOf('/cn2061/export') > -1) return '2061'
      return '2011'
    }
  }
}
